import { graphql } from "msw";
import {
  SellerRecommendedProductsQuery,
  SellerRecommendedProductsQueryVariables,
} from "@common-vendors/generated/graphql";
import { getMockRecommendedProduct } from "../mockRecommendedProducts";

export const handler = graphql.query<
  SellerRecommendedProductsQuery,
  SellerRecommendedProductsQueryVariables
>("SellerRecommendedProducts", (request, response, context) => {
  const { limit, offset } = request.variables;
  return response(
    context.data({
      __typename: "Query" as const,
      sellerRecommendedProducts: {
        __typename: "SellerRecommendedProductsResponse" as const,
        products: Array.from({ length: limit }, (_, index) =>
          getMockRecommendedProduct({ id: (index + 1).toString() })
        ),
        metaData: {
          hydrationErrorCount: 0,
          preHydrationCount: 1,
          postHydrationCount: 1,
          __typename: "RecommenderMetaData" as const,
        },
        pagination: {
          nextItemIndex: offset + limit,
          totalCount: 30,
        },
      },
    })
  );
});
